import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import './AboutCharity.scss';
import PageList from '../PageList/PageList';
import AboutOwner from '../AboutOwner/AboutOwner';

interface AboutCharityProps {
  charities: {
    id?: string;
    url?: string;
    logo: string;
    name?: string | null;
    profilePageUrl: string;
    description?: string | null;
    registrationNumber?: string | null;
  }[];
}

const AboutCharity: FunctionComponent<AboutCharityProps> = ({ charities }) => {
  if (charities.length > 1) {
    return (
      <>
        <PageList
          pages={charities.map(x => ({
            charityId: x.id,
            url: x.profilePageUrl,
            logo: x.logo,
          }))}
        />
        <FindOutMoreLink />
      </>
    );
  }

  if (charities.length === 1) {
    const charity = charities[0];
    return (
      <>
        <AboutOwner
          logo={charity.logo}
          name={charity.name || ''}
          ownerUrl={charity.profilePageUrl}
          description={charity.description || ''}
          registrationNumber={charity.registrationNumber || undefined}
          webAddress={charity.url}
        />
        <FindOutMoreLink />
      </>
    );
  }

  return null;
};

const FindOutMoreLink = () => (
  <a
    href="/fundraising"
    target="_blank"
    className="jg-about-charity__link jg-space-mtsm"
  >
    <Trans i18nKey="charity.findOutMore">
      Find out more about charity fundraising
    </Trans>
  </a>
);

export default AboutCharity;
